import { EbUser } from "./../classes/user";
import { EbEtablissement } from "../classes/etablissement";
import { Delegation } from "../classes/delegation";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, URLSearchParams } from "@angular/http";
import { SearchCriteria } from "../utils/searchCriteria";
import { AuthHttp, JwtHelper } from "angular2-jwt";
import { Statique } from "../utils/statique";
import { EbRelation } from "../classes/relation";
import { EbContactRequest } from "../classes/contactRequest";
import { TOKEN_NAME } from './auth.constant';
import { Inscription } from './../classes/inscription';
import { Subject } from "rxjs";
import "rxjs/add/operator/map";
import { AuthenticationService } from "./authentication.service";
import { EbFavori } from "../classes/favori";

@Injectable()
export class UserService {
	//jwtHelper: JwtHelper = new JwtHelper();
	//accessToken: string;

	constructor(private http: Http, private authHttp: AuthHttp, private authenticationService: AuthenticationService) { }

	resetPassword(email: string) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		return this.http
			.post(Statique.controllerAccount + "/reset-password", email, {
				headers: headers
			})
			.map(res => res.json());
	}

	changePassword(ebUser: EbUser) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		return this.http
			.post(Statique.controllerAccount + "/change-password-token", ebUser, {
				headers: headers
			})
			.map(res => res.json());
	}

	userInfo() {
		return this.authHttp
			.get(Statique.controllerAccount + "/account-settings")
			.map((res: Response) => res.json());
	}

	changeUserPassword(newUser: EbUser) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		let body = JSON.stringify(newUser);
		return this.authHttp
			.post(Statique.controllerAccount + "/changeUserPassword", body, {
				headers: headers
			})
			.map((res: Response) => res.json());
	}

	updateUser(newUser: EbUser) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		let body = JSON.stringify(newUser);
		return this.authHttp
			.post(Statique.controllerAccount + "/updateUser", body, {
				headers: headers
			})
			.map((res: Response) => res.json());
	}

	updateStatusUser(newUser: EbUser) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		let body = JSON.stringify(newUser);
		return this.authHttp
			.post(Statique.controllerAccount + "/updateStatusUser", body, {
				headers: headers
			})
			.map((res: Response) => res.json());
	}

	updateAdminAndSuperAdminUser(newUser: EbUser) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		let body = JSON.stringify(newUser);
		return this.authHttp
			.post(Statique.controllerAccount + "/updateAdminAndSuperAdminUser", body, {
				headers: headers
			})
			.map((res: Response) => res.json());
	}

	updateUserDetails(newUser: EbUser) {
		let headers = new Headers();
		let body = JSON.stringify(newUser);
		return this.authHttp
			.post(Statique.controllerAccount + "/updateUserDetails", body, {
				headers: headers
			})
			.map((res: Response) => res.json());
	}

	updateEtablissement(etablissement: EbEtablissement) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		let body = JSON.stringify(etablissement);
		return this.authHttp
			.post(Statique.controllerAccount + "/updateEtablissement", body, {
				headers: headers
			})
			.map((res: Response) => res.json());
	}

	matchUserPassword(ebUserNum: number, password: String) {
		let criteria: SearchCriteria = new SearchCriteria();
		criteria.ebUserNum = ebUserNum;
		criteria.ebUserPassword = password;
		return this.http
			.post(Statique.controllerAccount + "/check-user-password", criteria)
			.map(res => res.json());
	}

	listUser() {
		return this.authHttp.get(Statique.controllerAccount + "/allUser").map(res => res.json());
	}

	createDelegation(ebDelegation: Delegation) {
		let headers = new Headers();
		// headers.append("Content-Type", "application/json");
		// let body = JSON.stringify(ebDelegation);
		return this.authHttp
			.post(Statique.controllerAccount + "/create-delegation", ebDelegation)
			.map(res => res.json());
	}

	deleteDelegation(ebDelegationNum: number) {
		let headers = new Headers();
		return this.authHttp
			.post(Statique.controllerAccount + "/deleteDelegation", ebDelegationNum)
			.map(res => res.json());
	}

	getDelegation(criteria: SearchCriteria) {
		return this.authHttp
			.post(Statique.controllerAccount + "/get-delegation", criteria)
			.map(res => res.json());
	}

	static getConnectedUser(): EbUser {
		return AuthenticationService.getConnectedUser();
	}


	static isAuthenticated(): boolean {
		return AuthenticationService.isAuthenticated();
	}

	getUserInfo(searchCriteria?: SearchCriteria) {

		if (searchCriteria == null) {
			searchCriteria = new SearchCriteria();
		}

		if (UserService.getConnectedUser()) {
			searchCriteria.ebUserNum = UserService.getConnectedUser().ebUserNum;
		}
		return this.authHttp
			.post(Statique.controllerAccount + "/get-user", searchCriteria)
			.map(res => res.json());
	}

	getUserDetails(searchCriteria?: SearchCriteria) {

		if (searchCriteria == null) {
			searchCriteria = new SearchCriteria();
		}

		return this.authHttp
			.post(Statique.controllerAccount + "/get-user", searchCriteria)
			.map(res => res.json());
	}

	getUserContacts(searchCriteria: SearchCriteria) {
		return this.authHttp
			.post(Statique.controllerCommunity + "/get-contacts", searchCriteria)
			.map(res => res.json());
	}

	updateUserContacts(relation: EbRelation) {
		return this.authHttp
			.post(Statique.controllerCommunity + "/update-contact", relation)
			.map(res => res.json());
	}

	getEtablissementsContact(searchCriteria: SearchCriteria) {
		return this.authHttp
			.post(
			Statique.controllerCommunity + "/get-etablissements-contact",
			searchCriteria
			)
			.map(res => res.json());
	}

	getUserSendingRequest(searchCriteria: SearchCriteria) {
		return this.authHttp
			.post(
			Statique.controllerCommunity + "/get-sending-request",
			searchCriteria
			)
			.map(res => res.json());
	}

	getUserReceivingRequest(searchCriteria: SearchCriteria) {
		return this.authHttp
			.post(
			Statique.controllerCommunity + "/get-receiving-request",
			searchCriteria
			)
			.map(res => res.json());
	}

	accepterRelation(ebRelation: EbRelation) {
		return this.authHttp
			.post(Statique.controllerCommunity + "/accepter-relation", ebRelation)
			.map(res => res.json());
	}

	ignorerRelation(ebRelation: EbRelation) {
		return this.authHttp
			.post(Statique.controllerCommunity + "/ignorer-relation", ebRelation)
			.map(res => res.json());
	}

	annulerRelation(ebRelation: EbRelation) {
		return this.authHttp
			.post(Statique.controllerCommunity + "/annuler-relation", ebRelation)
			.map(res => res.json());
	}

	getListUser(searchCriteria: SearchCriteria) {
		return this.authHttp.post(Statique.controllerCommunity + '/get-list-user', searchCriteria)
			.map(res => res.json());
	}

	sendInvitaion(ebRelation: EbRelation) {
		return this.authHttp.post(Statique.controllerCommunity + '/send-invitaion', ebRelation)
			.map(res => res.json());
	}

	sendInvitationMail(inscription: Inscription) {
		let headers = new Headers();
		headers.append("Content-Type", "application/json");
		let body = JSON.stringify(inscription);
		console.log(body);
		return this.authHttp
			.post(Statique.controllerAccount + "/invitation", body, {
				headers: headers
			})
			.map((res: Response) => res.json());
	}

	sendInvitationByMail(ebRelation: EbRelation) {
		return this.authHttp.post(Statique.controllerCommunity + '/send-invitaion-bymail', ebRelation)
			.map(res => res.json());
	}

	updatePasswordUser(ebUser: EbUser) {
		return this.authHttp.post(Statique.controllerAccount + '/update-password-user', ebUser)
			.map(res => res.json());
	}

	activationCompte(activationCode: Boolean) {
		return this.http.get(Statique.controllerInscription + "/activation-compte/" + activationCode)
			.map((res: Response) => res.json());
  }

  refuseUser(user: EbUser) {
		return this.http.post(Statique.controllerAccount + "/refuse-user" ,user)
			.map((res: Response) => res.json());
  }

  getUserContactsByEtablissement(searchCriteria: SearchCriteria) {
	return this.authHttp
		.post(Statique.controllerCommunity + "/get-one-etablissement-contact", searchCriteria)
		.map(res => res.json());
	}

  saveConfigEmail(user: EbUser) {
		return this.authHttp.post(Statique.controllerAccount + "/save-config-params-mail" ,user)
			.map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts